import { Transaction } from "@common/types/transaction";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { AnimatedSearchIcon } from "@icons";
import React, { useCallback, useState } from "react";

interface Props {
    transaction: Pick<Transaction, "bankDescription">;
}

export const TransactionGoogleSearchButton: React.FC<Props> = ({
    transaction,
}) => {
    const { transactionGoogleSearch } = useTypedFlags();
    const [isAnimating, setIsAnimating] = useState(false);
    const searchQuery = transaction.bankDescription;

    const handleSearchGoogle = useCallback(() => {
        if (!searchQuery) {
            return;
        }
        window.open(
            `https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`,
            "_blank",
            "noopener,noreferrer",
        );
    }, [searchQuery]);

    if (!transactionGoogleSearch || !searchQuery) {
        return null;
    }

    return (
        <Tooltip content="Search on Google">
            <Button
                variant="secondary"
                iconOnly
                onClick={handleSearchGoogle}
                onMouseEnter={() => setIsAnimating(true)}
                onMouseLeave={() => setIsAnimating(false)}
                aria-label="Search on Google"
                data-testid="transaction-details-google-search"
                size="sm"
            >
                <AnimatedSearchIcon isAnimating={isAnimating} />
            </Button>
        </Tooltip>
    );
};
